import React, { Fragment, useEffect, useState } from "react";
import moment from "moment";
import ReactGA from 'react-ga';
import { useTranslation } from "react-i18next";
import { Button, Media } from "reactstrap";

import defaultImage from '../../../../images/redesign/common/default_image.svg';
import lightDefaultImage from '../../../../images/redesign/light-mode/common/default_image.svg';

import helpImg from '../../../../images/redesign/Chat button small.svg'
import helpImgLight from '../../../../images/redesign/light-mode/icons/chat-light-icon.svg';

import wheel from '../../../../images/redesign/Daily bonus button small.svg';

import tournamentsIcon from '../../../../images/icons/tournamentsL.png';
import fourPRoom from '../../../../images/icons/4p_room.svg';
import threePRoom from '../../../../images/icons/3p_room.svg';
import twoPRoom from '../../../../images/icons/2p_room.svg';
import powerRanking from '../../../../images/redesign/mobile/icons/power-ranking-menu-active-icon.svg'
import top from '../../../../images/redesign/mobile/icons/top-menu-active-icon.svg'
import shop from '../../../../images/redesign/Shop button.png';

import { ACHIEVEMENT_DATA, MENU_NAVIGATION, SCREEN_MODE, SCREENS, USER_NOTIFICATIONS } from "../../../../constants/constants";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setJoinTournamentIdTrigger, setOpenLuckyWheelHistoryTrigger } from "../../../../actions/state";
import { clearUserNotifications, getGiftsHistory, getUserNotificationsLive, markAsReadUserNotifications, removeGift, removeUserNotification, setUserNotifications, setUserScreenViewNew, stopGetUserNotificationsLive } from "../../../../actions/member";
import ModalQuestion from "../Components/Components/ModalQuestion";
import CustomModal from "../Components/Components/Modal";
import { getTournamentTitle } from "../../../../utils/tournamentUtils";
import TournamentInfo from "./Tournaments/Components/TournamentInfo";
import TournamentInfoMobile from "./Tournaments/Mobile/Components/TournamentInfo";
const gift = 'https://firebasestorage.googleapis.com/v0/b/zole-app.appspot.com/o/gifts2%2Fcoffee.svg?alt=media&token=94f3b01f-7348-42ec-b43e-311da09a10b0';

const getAchievementImg = (achievement, claimedAchievementValue) => {
    const borders = ACHIEVEMENT_DATA[achievement].borders;
    
    let img;

    let imgKey = achievement;
    if (achievement === 'highestEarned') imgKey = 'balance';

    try {
        const index = claimedAchievementValue - 1;

        if (borders[index + 1]) {
            // eslint-disable-next-line
            img = require(`../../../../images/Ach/${imgKey}_${borders[index]}_${borders[index + 1]}.png`);
        } else {
            // eslint-disable-next-line
            img = require(`../../../../images/Ach/${imgKey}_${borders[index]}.png`);
        }
    } catch (e) {
        console.log(e);
    }

    return img;
}

const getAchievementName = (achievement, claimedAchievementValue, language, t) => {
    const translationKeys = ACHIEVEMENT_DATA[achievement].translationKeys[language];
    const borders = ACHIEVEMENT_DATA[achievement].borders;

    const index = claimedAchievementValue - 1;
    const nameKey = translationKeys[index] || translationKeys[translationKeys.length - 1];
    const name = t(`achievements:${nameKey}`);

    const val = borders[index] >= 1000 ? `${borders[index] / 1000}k` : borders[index];
    const hideNumber = (ACHIEVEMENT_DATA[achievement].dontShowValue === 'first' && index === 0) || ACHIEVEMENT_DATA[achievement].dontShowValue === 'all';
    const placeNumberAfterText = ACHIEVEMENT_DATA[achievement].numPlacement === 'after';

    return `${hideNumber || placeNumberAfterText ? '' : val} ${t(name)}${placeNumberAfterText ? ` ${val}` : ''}`;
}

const getAchievementReward = (achievement, claimedAchievementValue) => {
    const rewards = ACHIEVEMENT_DATA[achievement].rewards;
    const index = claimedAchievementValue - 1;
    return rewards[index];
}

function UserNotifications({
    toggle,
    isOpen,
    userNotifications,
    userNotificationsUnreadCount,
    history,
    notificationSettings,
    changeTab,
    getGiftsHistoryFunc,
    removeGiftFunc,
    fontMode,
    toggleSupport,
    setOpenLuckyWheelHistoryTriggerFunc,
    setJoinTournamentIdTriggerFunc,
    tournaments,
    setScreenViewNew,
    toggleBalanceHistory,
    screenMode,
    member,
    // setUserNotificationsFunc,
    getUserNotificationsLiveFunc,
    stopGetUserNotificationsLiveFunc,
    removeUserNotificationFunc,
    clearUserNotificationsFunc,
    markAsReadUserNotificationsFunc,
    windowWidth,
}) {

    const { t, i18n } = useTranslation(/*['common']*/);

    const [removeGiftModalOpen, setRemoveGiftModalOpen] = useState(false);
    const [removeGiftError, setRemoveGiftError] = useState(null);
    const [removeGiftSelected, setRemoveGiftSelected] = useState(null);

    const [tournamentInfoModalOpen, setTournamentInfoModalOpen] = useState(false);
    const [selectTournament, setSelectTournament] = useState(null);

    useEffect(() => {
        getUserNotificationsLiveFunc(member.uid);

        return () => {
            stopGetUserNotificationsLiveFunc(member.uid);
        };
    }, []);


    // useEffect(() => {
    //     const handleKeyDown = (event) => {
    //         if (event.key.toLowerCase() === "x") {
    //             setUserNotificationsFunc(member.uid);
    //         }
    //     };

    //     window.addEventListener("keydown", handleKeyDown);

    //     return () => {
    //         window.removeEventListener("keydown", handleKeyDown);
    //     };
    // }, []);

    const getDefaultImage = () => {
        if (screenMode === SCREEN_MODE.light) return lightDefaultImage;
        return defaultImage;
    }
    const getHelpImg = () => {
        if (screenMode === SCREEN_MODE.light) return helpImgLight;
        return helpImg;
    }

    const changeTabWrapper = (tab) => {
        toggle();
        changeTab(tab);
    }

    const toggleSupportWrapper = () => {
        toggle();
        toggleSupport();
    }

    const toggleBalanceHistoryWrapper = () => {
        toggle();
        toggleBalanceHistory();
    }

    const openLuckyWheelHistory = () => {
        toggle();
        changeTabWrapper(MENU_NAVIGATION.bonusPage);
        setOpenLuckyWheelHistoryTriggerFunc(true);
    }

    const joinTournament = (tournamentId) => {
        changeTabWrapper(MENU_NAVIGATION.futureTournaments);
        setJoinTournamentIdTriggerFunc(tournamentId);

    }

    const openTournamentInfoModal = (selectId) => {
        toggle();
        setScreenViewNew(SCREENS.TOURNAMENTS.INFO);

        setTournamentInfoModalOpen(true);
        setSelectTournament({ ...tournaments.filter(tournament => tournament.id === selectId)[0] });
    }

    const openRoomResults = (roomId, roomPlayerCount) => {
        if (roomPlayerCount === 2) {
            history.push(`/student-zole/${roomId}`);
        } else {
            history.push(`/zole/${roomId}`);
        }
    }

    const startRemoveGift = (giftId) => {
        if (notificationSettings && notificationSettings.removeGift === false) {
            approveRemove(giftId);
        } else {
            setRemoveGiftSelected(giftId);
            setRemoveGiftModalOpen(true);
        }
    }

    const closeRemoveGiftModal = () => {
        setRemoveGiftSelected(null);
        setRemoveGiftModalOpen(false);
    }

    const closeRemoveGiftErrorModal = () => {
        setRemoveGiftError(null);
        setRemoveGiftModalOpen(false);
        setRemoveGiftSelected(null);
    }

    const buyMoney = () => {
        closeRemoveGiftErrorModal();
        changeTabWrapper(MENU_NAVIGATION.buyPageMoneyPacks);
    }

    const approveRemove = (passedGift) => {
        if (passedGift) {
            removeGiftFunc(passedGift, member.giftsHistory[passedGift]).then((res) => {
                if (res && res.data && res.data.status === 'success') {
                    getGiftsHistoryFunc();
            
                    ReactGA.event({
                        category: 'Menu',
                        action: 'Remove Gift',
                    });
                }
        
                if (res && res.data && (res.data.status === 'error' && res.data.message === 'low balance')) {
                    setRemoveGiftError('lowBalance');
                    setRemoveGiftModalOpen(false);
                    setRemoveGiftSelected(null);
                } else {
                    setRemoveGiftSelected(null);
                    setRemoveGiftModalOpen(false);
                }
            });
        } else if (removeGiftSelected) {
            removeGiftFunc(removeGiftSelected, member.giftsHistory[removeGiftSelected]).then((res) => {
                if (res && res.data && res.data.status === 'success') {
                    getGiftsHistoryFunc();
            
                    ReactGA.event({
                        category: 'Menu',
                        action: 'Remove Gift',
                    });
                }
        
                if (res && res.data && (res.data.status === 'error' && res.data.message === 'low balance')) {
                    setRemoveGiftError('lowBalance');
                    setRemoveGiftModalOpen(false);
                    setRemoveGiftSelected(null);
                } else {
                    setRemoveGiftSelected(null);
                    setRemoveGiftModalOpen(false);
                }
            });
        }
    }

    const markAsReadWrapper = () => {
        toggle();
        markAsReadUserNotificationsFunc();
    }

    const sortedNotifications = Object.entries(userNotifications)
        .sort(([, a], [, b]) => b.date - a.date);

    return (
        <Fragment>
            {isOpen && (
                <div
                    className="user-notifications-new"
                >
                    <div className="user-notifications-new-header">
                        {t(`userNotifications:title`)}

                        <div
                            className="user-notifications-new-header-close"
                            onClick={toggle}
                        />
                    </div>

                    <div className="user-notifications-new-body">

                        {sortedNotifications.length === 0 && (
                            <div className="user-notifications-new-body-empty">
                                {t(`userNotifications:empty`)}
                            </div>
                        )}
                        {sortedNotifications.map(([id, item]) => {

                            let notificationImg;
                            const notificationTitle = t(`userNotifications:${item.notificationType}.title`);
                            let notificationDescription;
                            let notificationButtons;


                            if (item.notificationType === USER_NOTIFICATIONS.achievement) {
                                notificationImg = getAchievementImg(item.achievement, item.claimedAchievementValue);

                                const achievementName = getAchievementName(item.achievement, item.claimedAchievementValue, i18n.language, t);
                                const achievementReward = getAchievementReward(item.achievement, item.claimedAchievementValue);

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { achievementName, achievementReward });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.archievements)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.friend) {
                                notificationImg = item.photo || getDefaultImage();
                                const name = item.name;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { name });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.friends)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.friendCoins) {
                                notificationImg = item.photo || getDefaultImage();
                                const name = item.name;
                                const coins = item.coins;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { name, coins });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.friends)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.gift) {
                                notificationImg = item.image;
                                const name = item.name;
                                const giftId = item.giftId;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { name });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.myInfo)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => startRemoveGift(giftId)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText2`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.supportMessage) {
                                notificationImg = getHelpImg();

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`);

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => toggleSupportWrapper()}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.luckyWheel) {
                                notificationImg = wheel;

                                const coinsWithSign = item.coins;
                                const coins = Math.abs(coinsWithSign);

                                notificationDescription = coins > 0
                                    ? t(`userNotifications:${item.notificationType}.description`, { coins })
                                    : t(`userNotifications:${item.notificationType}.description2`, { coins });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => openLuckyWheelHistory()}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.tournament) {
                                notificationImg = tournamentsIcon;

                                const title = item[`title${i18n.language.toUpperCase()}`];
                                const tournamentId = item.tournamentId;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { title });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => openTournamentInfoModal(tournamentId)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => joinTournament(tournamentId)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText2`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.roomComplete) {
                                notificationImg = item.names.length === 3
                                    ? threePRoom
                                    : item.names.length === 4
                                        ? fourPRoom
                                        : twoPRoom;

                                const names = item.names.join(', ');
                                const coinsWithSign = item.coins;
                                const pointsWithSign = item.points;
                                const coins = Math.abs(coinsWithSign);
                                const points = Math.abs(pointsWithSign);
                                const roomId = item.roomId;
                                const roomPlayerCount = item.names.length;

                                notificationDescription = coinsWithSign > 0
                                    ? t(`userNotifications:${item.notificationType}.description`, { names, coins, points })
                                    : t(`userNotifications:${item.notificationType}.description2`, { names, coins, points });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => openRoomResults(roomId, roomPlayerCount)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.ignored) {
                                notificationImg = item.photo || getDefaultImage();

                                const name = item.name;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { name });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.ignoredUsers)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.powerRanking) {
                                notificationImg = powerRanking;

                                const sorting = item.sorting;
                                const number = item.number;
                                const category = item.category;

                                notificationDescription = sorting === 'best'
                                    ? t(`userNotifications:${item.notificationType}.description`, { number, category })
                                    : t(`userNotifications:${item.notificationType}.description2`, { number, category })


                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.powerRankings)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.top) {
                                notificationImg = top;

                                const category = item.category;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { category });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.top)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.adminCoins) {
                                notificationImg = getHelpImg();

                                const coins = item.coins;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { coins });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => toggleSupportWrapper()}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => toggleBalanceHistoryWrapper()}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText2`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.purchase) {
                                notificationImg = shop;

                                const name = item.name;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { name });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => changeTabWrapper(MENU_NAVIGATION.buyPageHistory)}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            } else if (item.notificationType === USER_NOTIFICATIONS.giftCode) {
                                notificationImg = gift;

                                const coins = item.coins;

                                notificationDescription = t(`userNotifications:${item.notificationType}.description`, { coins });

                                notificationButtons = (
                                    <>
                                        <button
                                            className="user-notifications-new-body-item-bottom-buttons-button layout-default-button"
                                            onClick={() => toggleBalanceHistoryWrapper()}
                                        >
                                            {t(`userNotifications:${item.notificationType}.buttonText`)}
                                        </button>
                                    </>
                                );
                            }

                            return (
                                <div key={id} className="user-notifications-new-body-item">
                                    {!item.read && <div className="user-notifications-new-body-item-unread" />}

                                    <div className="user-notifications-new-body-item-top">
                                        <Media src={notificationImg} className="user-notifications-new-body-item-top-img" />
                                        <div className="user-notifications-new-body-item-top-content">
                                            <div className="user-notifications-new-body-item-top-content-title">
                                                
                                                <span className="user-notifications-new-body-item-top-content-title-text">
                                                    {notificationTitle}
                                                </span>

                                                <div
                                                    className="user-notifications-new-body-item-top-content-title-delete"
                                                    onClick={() => removeUserNotificationFunc(id)}
                                                >
                                                    X
                                                </div>
                                            </div>

                                            <span className="user-notifications-new-body-item-top-content-description">
                                                {notificationDescription}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="user-notifications-new-body-item-bottom">
                                        <span>{moment(item.date).format('DD-MM-YYYY HH:mm')}</span>

                                        <div className="user-notifications-body-item-bottom-buttons">
                                            {notificationButtons}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className="user-notifications-new-footer">
                        <button
                            className="user-notifications-new-footer-button layout-default-button"
                            onClick={() => clearUserNotificationsFunc()}
                            disabled={sortedNotifications.length === 0}
                        >
                            {t(`userNotifications:clearAll`)}
                        </button>
                        <button
                            className="user-notifications-new-footer-button layout-default-button"
                            onClick={() => markAsReadWrapper()}
                            disabled={userNotificationsUnreadCount === 0}
                        >
                            {t(`userNotifications:markAll`)}
                        </button>
                    </div>

                </div>
            )}

            <ModalQuestion
                isOpen={removeGiftModalOpen}
                toggle={closeRemoveGiftModal}
                title={t('common:myInfo.deleteGift')}
                footer={(
                    <>
                        <Button type="button" className="question-modal-approve-btn" color="link" onClick={() => approveRemove()}>
                            {t('common:common.yes')}
                        </Button>
                        <Button type="button" className="question-modal-decline-btn" color="link" onClick={closeRemoveGiftModal}>
                            {t('common:common.no')}
                        </Button>
                    </>
                )}
                body={(
                    <>
                        {t('common:myInfo.deleteGiftMessage')}
                    </>
                )}
            />

            <CustomModal
                isOpen={!!removeGiftError}
                toggle={() => { setRemoveGiftError(null); setRemoveGiftModalOpen(false); }}
                size="md"
                verticalCentering
                largeText
                title={t('common:home.notifications')}
                footer={(
                    <>
                        {removeGiftError === 'lowBalance' ? (
                            <Button color="link" onClick={() => buyMoney()}>{t('myInfo.buyMoney')}</Button>
                        ) : (null)}
                        <Button type="button" color="link" onClick={() => { setRemoveGiftError(null); setRemoveGiftModalOpen(false); }}>
                            {t('common:common.close')}
                        </Button>
                    </>
                )}
                body={(
                    <p className="text-center">
                        {removeGiftError === 'lowBalance' ? t('common:myInfo.notEnoughMoneyRemoveGift') : t('common:myInfo.deleteGiftError')}
                    </p>
                )}
            />

            <CustomModal
                isOpen={tournamentInfoModalOpen}
                toggle={() => setTournamentInfoModalOpen(false)}
                size="lg"
                title={getTournamentTitle(selectTournament)}
                footer={
                    <Button color="link" className="btn notification-footer-button" onClick={() => setTournamentInfoModalOpen(false)}>
                        {t('common:common.close')}
                    </Button>
                }
                body={
                    windowWidth > 1280 ? (
                        <TournamentInfo t={t} selectTournament={selectTournament} />
                    ) : (
                        <TournamentInfoMobile t={t} selectTournament={selectTournament} />
                    )
                    
                }
            />
        </Fragment>
    );
}

const mapStateToProps = state => ({
    userNotifications: state.member.userNotifications,
    userNotificationsUnreadCount: state.member.userNotificationsUnreadCount,
    registeredTournament: state.member.registeredTournament,
    tournaments: (state.tournaments && state.tournaments.tournaments) ? state.tournaments.tournaments : [],
    member: state.member,
});

const mapDispatchToProps = {
    setOpenLuckyWheelHistoryTriggerFunc: setOpenLuckyWheelHistoryTrigger,
    setJoinTournamentIdTriggerFunc: setJoinTournamentIdTrigger,
    setScreenViewNew: setUserScreenViewNew,
    setUserNotificationsFunc: setUserNotifications,
    getUserNotificationsLiveFunc: getUserNotificationsLive,
    stopGetUserNotificationsLiveFunc: stopGetUserNotificationsLive,

    removeUserNotificationFunc: removeUserNotification,
    clearUserNotificationsFunc: clearUserNotifications,
    markAsReadUserNotificationsFunc: markAsReadUserNotifications,


    getGiftsHistoryFunc: getGiftsHistory,
    removeGiftFunc: removeGift,

};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(UserNotifications)
);